import { useSelector } from 'react-redux'
import { Box } from '@mui/material'
import {
  PopulationDistribution,
  PopulationEvolution,
  PopulationHeader,
  PopulationSummary,
  SankeyChartContainer,
  useI18n,
} from '@popety_io/popety-io-lib'
import { estimateSelector } from '../../redux'

const EstimatePopulation = () => {
  const { t } = useI18n()
  const estimate = useSelector(estimateSelector)

  const isPopulationByAge =
    !!estimate?.isPopulationByAge || estimate?.isPopulationByAge === undefined
  const isPopulationByHousehold =
    !!estimate?.isPopulationByHousehold ||
    estimate?.isPopulationByHousehold === undefined
  const isPopulationByResidenceYear =
    !!estimate?.isPopulationByResidenceYear ||
    estimate?.isPopulationByResidenceYear === undefined
  const isPopulationBySwissOrForeign =
    !!estimate?.isPopulationBySwissOrForeign ||
    estimate?.isPopulationBySwissOrForeign === undefined
  const isPopulationByGender =
    !!estimate?.isPopulationByGender ||
    estimate?.isPopulationByGender === undefined
  const isSankeyChart =
    !!estimate?.isSankeyChart || estimate?.isSankeyChart === undefined
  const isPopulationEvolution =
    !!estimate?.isPopulationEvolution ||
    estimate?.isPopulationEvolution === undefined

  return (
    <Box>
      <Box
        id="estimate-population-top"
        display="flex"
        flexDirection="column"
        gap={3}
      >
        <PopulationHeader />
      </Box>
      <Box>
        <PopulationSummary loading={false} data={estimate.populationSummary} />
        {isPopulationEvolution && (
          <PopulationEvolution
            data={estimate.populationByYear}
            title={t('common.evolution_population')}
            legendTitle={estimate?.populationTitle}
            regionName={estimate?.region_name}
          />
        )}
        {isPopulationByAge && (
          <PopulationDistribution
            data={estimate.populationByAge}
            title={t('common.population_by_age')}
            regionName={estimate?.region_name}
            legendTitle={estimate?.populationTitle}
            endAdornment={t('common.personnes')}
          />
        )}
        {isPopulationByHousehold && (
          <PopulationDistribution
            data={estimate.populationByHousehold}
            title={t('common.population_by_households')}
            regionName={estimate?.region_name}
            legendTitle={estimate?.populationTitle}
            endAdornment={t('common.households')}
          />
        )}
        {isPopulationByResidenceYear && (
          <PopulationDistribution
            data={estimate.populationByResidenceYear}
            title={t('common.population_by_residence_year')}
            regionName={estimate?.region_name}
            legendTitle={estimate?.populationTitle}
            endAdornment={t('common.personnes')}
          />
        )}
        {isPopulationBySwissOrForeign && (
          <PopulationDistribution
            data={estimate.populationBySwissOrForeign}
            title={t('common.population_by_swiss_or_foreign')}
            regionName={estimate?.region_name}
            legendTitle={estimate?.populationTitle}
            endAdornment={t('common.personnes')}
          />
        )}
        {isPopulationByGender && (
          <PopulationDistribution
            data={estimate.populationByGender}
            title={t('common.population_by_gender')}
            regionName={estimate?.region_name}
            legendTitle={estimate?.populationTitle}
            endAdornment={t('common.personnes')}
          />
        )}
        {isSankeyChart && (
          <SankeyChartContainer
            title={t('common.population_distribution')}
            data={estimate.populations}
          />
        )}
      </Box>
    </Box>
  )
}

export default EstimatePopulation
